import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "revico-community-talk-title" }
const _hoisted_2 = { class: "revico-community-talk-title--text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createElementVNode("h1", _hoisted_2, [
      _createVNode(_component_font_awesome_icon, { icon: "fa-regular fa-message" }),
      _createTextVNode(_toDisplayString($props.title), 1 /* TEXT */)
    ])
  ]))
}